





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';

@Component({
  name: 'bpc-pos-add-badge-modal',
  components: {
    BpcInput,
  },
})
export default class PosAddBadgeModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly confirmDisabled: boolean;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly contactId!: number;
  // DATA
  addingBadge = false;
  badgeNumber = '';

  // COMPUTED
  // LIFECYCLE
  // METHODS

  closeModal() {
    this.$emit('close');
    this.badgeNumber = '';
  }

  async onConfirm() {
    this.addingBadge = true;
    try {
      const posContact = await this.$posService.addContactBadge(
        this.posSessionId,
        this.contactId,
        this.badgeNumber,
      );
      this.$emit('contact-updated', posContact);
      this.closeModal();
    } catch (error) {
      this.handleError(error);
    }

    this.addingBadge = false;
    this.badgeNumber = '';
  }

  handleError(error: any) {
    console.log(error);
  }
  // WATCHERS
}
